import { Header } from '../components/Header'
import { useUsers } from '@hooks/useUsers'
import { Table } from '../components/Table'
import { Spinner } from 'components/loaders'
import { useProjectIntegrations } from '@hooks/useProjectIntegrations'
import { useEmployees } from '@hooks/useEmployee'
import { MenuButton } from 'components/buttons'
import { useTranslation } from 'react-i18next'
import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { useNewUser } from '../hooks/useNewUser'

export const UsersAdmin = () => {
  const { t } = useTranslation()
  const { data: users } = useUsers()
  const { data: employees } = useEmployees()
  const { data: projectIntegrations } = useProjectIntegrations()
  const { newUser } = useNewUser()

  const usersWithEmployees = users?.map((user) => {
    return {
      ...user,
      employee: employees?.find((employee) => employee.user.id === user.id),
    }
  })

  return (
    <div className="flex flex-col flex-grow">
      <Header
        actionButton={
          <MenuButton
            className="ml-2"
            title={t('common.action')}
            menuItems={[
              {
                icon: faPlus,
                label: t('features.usersAdmin.addUser'),
                onClick: newUser,
              },
            ]}
          >
            {t('common.action')}
          </MenuButton>
        }
      />
      {usersWithEmployees && users && employees && projectIntegrations ? (
        <Table
          projectIntegrations={projectIntegrations}
          users={usersWithEmployees}
        />
      ) : (
        <Spinner />
      )}
    </div>
  )
}